import { DETAILS_MODAL_ACTIONS } from './constants';

const initialState = {
  isFetching: false,
  isError: false,
  data: null,
  position: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL: {
      return {
        ...state,
        isFetching: true,
        isError: false,
      };
    }
    case DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        isError: false,
        data: action.payload,
      };
    }
    case DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL_ERROR: {
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    }
    case DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_FAVORITE: {
      return {
        ...state,
        data: {
          ...state.data,
          isFavorite: action.payload.includes(state.data?.id),
        },
      };
    }
    case DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_COMPARE: {
      return {
        ...state,
        data: {
          ...state.data,
          isCmp: action.payload.includes(state.data?.id),
        },
      };
    }
    case DETAILS_MODAL_ACTIONS.SET_DEVICE_POSITION: {
      return {
        ...state,
        position: action.payload,
      };
    }
    default:
      return state;
  }
}
